import React from 'react'

import KinerjaPsIndex from 'app/KinerjaPSPage/pages'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPengawas from 'app/KinerjaPSPage/components/PageGuardPengawas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ps-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = (props: PageProps) => (
  <PageGuardPengawas>
    <KinerjaTipeProvider tipe="SPF">
      <KinerjaPsIndex {...props} />
    </KinerjaTipeProvider>
  </PageGuardPengawas>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengawas Sekolah Sebagai Tim Kerja',
}

export default Page
